var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBossManagerSuitWorkOffice = function SvgBossManagerSuitWorkOffice(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 46.462V40.25a3.954 3.954 0 0 0-1.54-3.158c-2.66-2.03-9-5.63-20.46-5.63s-17.79 3.6-20.46 5.63A3.956 3.956 0 0 0 2 40.25v6.212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.352 32.434 9.454 39.78a1 1 0 0 0 .126 1.262l5.42 5.42m18.388-14.084L24 46.462l-9.388-14.084m19.036.056 4.898 7.346a1 1 0 0 1-.126 1.262L33 46.462M24 27.48a12.97 12.97 0 1 0 0-25.94 12.97 12.97 0 0 0 0 25.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.946 11.358A4.054 4.054 0 1 1 24 15.41v2.162m0 5.614a.75.75 0 0 1 0-1.5m0 1.5a.75.75 0 0 0 0-1.5"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBossManagerSuitWorkOffice);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "boss-manager-suit-work-office.3025557b5fd3bbbbcfe2bef037b38428.svg";